import { SVGProps, Ref, forwardRef } from 'react';

export const BubbleDotRoundOutlinedSize16Glyph = forwardRef(
    (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
        <svg
            width={16}
            height={16}
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <g>
                <g>
                    <path
                        d="M8 .5c.846 0 1.692.061 2.5.196v1.422A13.6 13.6 0 0 0 8 1.9c-1.878 0-3.603.327-4.808 1.011C2.073 3.547 1.4 4.475 1.4 5.955c0 1.408.609 2.304 1.602 2.93 1.072.676 2.628 1.043 4.387 1.112l1.344.053v2.63l.28-.203c.941-.68 1.895-1.383 2.758-2.13 1.8-1.558 2.83-3 2.83-4.392q-.001-.237-.025-.455h1.405q.018.222.019.455c0 3.195-3.568 5.778-6.44 7.855l-.827.601c-.518.38-.994.744-1.399 1.089v-4.103C3.568 11.249 0 9.817 0 5.954 0 1.865 4 .5 8 .5"
                        fill="currentColor"
                    />
                    <path d="M11.331 6.7H4.666V5.298h6.665z" fill="currentColor" />
                    <path d="M14 0c1.5 0 2 1 2 2s-.5 2-2 2-2-1-2-2 .5-2 2-2" fill="currentColor" />
                </g>
            </g>
        </svg>
    )
);
BubbleDotRoundOutlinedSize16Glyph.displayName = 'BubbleDotRoundOutlinedSize16Glyph';
